import querystring from "querystring";

export const partnerFilterToParams = (params) => {
  const values: any = {
    filter: params ? JSON.stringify(params) : null,
  };

  return querystring.stringify(values);
};

export const processPartnerFilters = (params) => ({
  filter: params.get("filter") ? JSON.parse(params.get("filter")) : null,
});
